<script>
	import { slugify } from "./utils.js";
	import { activeFeature, activeMetric } from "./stores.js";

	$: getHtml = () => {
		let cc = $activeFeature.properties.popular_cc;
		return `
	<a href="${$activeFeature.properties.popular_cc_link}" target="_blank">	
		<img alt=${cc} src="assets/${slugify(cc)}.svg" />
	</a>`;
	};
</script>

<p>
	Most popular
	<br />
	credit card type
</p>
{@html getHtml()}
